import React, { FC } from 'react'
import { Block, Wrapper, Text, Divider, BottomWrapper } from './styled'

export const Footer: FC = () => (
	<Block>
		<Wrapper>
			<Text>
				<p>
					Реклама. Рекламодатель ПАО Сбербанк. ИНН 7707083893. Сервис «Своё дело» (далее Сервис)
					предоставляет ПАО Сбербанк (118997, г. Москва, ул. Вавилова, 19. ОГРН 1027700132195,
					Генеральная лицензия Банка России на осуществление банковских операций № 1481 от
					11.08.2015). Подробнее о сервисе «Своё дело» на сайте&nbsp;
					<a href="https://www.sberbank.com/ru/svoedelo/start">
						https://www.sberbank.com/ru/svoedelo/start
					</a>
					.
				</p>
			</Text>
			<Divider />
			<BottomWrapper>
				<Text>
					Конструктор документов предоставляется в рамках специального предложения партнёром ООО
					«ДОКЗИЛЛА» (ОГРН 1137746153819, ИНН 7709923315; адрес места нахождения: 125047, г. Москва,
					улица Бутырский Вал, дом 10). Участнику будет предоставлен бесплатный доступ к документам
					в разделе «Документы для самозанятых». «Юридическая консультация» для самозанятых
					предоставляется партнёром ООО «СБЕР ЛИГАЛ» (ОГРН 1187746905004, ИНН 9705124940; адрес
					места нахождения: 121170, г. Москва, улица Поклонная, дом 3, офис 209, этаж 2).
				</Text>
				<Text>
					В рамках специального предложения участнику предоставляется одна устная бесплатная
					консультация юриста от сервиса «СберПраво». Сервис для онлайн-записи и учёта клиентов
					предоставляется ООО «Сбер Бизнес Софт» (ОГРН 1217700484814, ИНН 7730269550; адрес места
					нахождения: 121170, г. Москва, улица Кутузовский проспект, дом 32, корпус 1, помещение
					7.C.18). В рамках тарифа «Базовый» участнику будет предоставлен бесплатный доступ к
					SberCRM — онлайн-сервису (веб-приложению) в интернете, расположенному по адресу. «Сайт для
					своего дела» предоставляется ООО &quot;Инсейлс Рус&quot; (107078, г. Москва, Новорязанская
					улица, д.18, строение 11, ИНН 7714843760, ОГРН 1117746506514).
				</Text>
			</BottomWrapper>
		</Wrapper>
	</Block>
)
